const es = {
"front.faq.chat.title": "HAZ UNA PREGUNTA",
"front.faq.chat.description": "soporte inmediato para los huéspedes del restaurante",
"front.faq.chat.welcome": "Aquí puedes hacer una pregunta directamente.",
"front.faq.chat.placeholder": "mensaje",
"front.faq.chat.send": "enviar",
"front.faq.chat.unsupportedLanguage": "Lo sentimos, este chat actualmente solo admite inglés y alemán.",
"front.faq.chat.fallback": "Gracias por tu mensaje. Por el momento solo puedo responder preguntas frecuentes. Ponte en contacto con nosotros directamente para obtener más información.",

"front.faq.chat.answer.hours": "Estamos abiertos todos los días de 10:00 a 22:00.",
"front.faq.chat.answer.reservation": "Sí, puedes reservar una mesa directamente en nuestro sitio web o por teléfono.",
"front.faq.chat.answer.groupReservation": "Para reservas de grupo, ponte en contacto con nosotros directamente para que podamos encontrar la mejor opción para ti.",
"front.faq.chat.answer.address": "Nuestra dirección es: Musterstraße 1, Berlín.",
"front.faq.chat.answer.parking": "Sí, hay aparcamiento disponible cerca.",
"front.faq.chat.answer.phone": "Puedes contactarnos en el número +49 000 000000.",
"front.faq.chat.answer.payment": "Sí, puedes pagar en efectivo o con tarjeta.",
"front.faq.chat.answer.menu": "Puedes encontrar nuestro menú actual en el sitio web. Si tienes preguntas sobre platos específicos, estaremos encantados de ayudarte.",
"front.faq.chat.answer.vegetarian": "Sí, ofrecemos platos vegetarianos.",
"front.faq.chat.answer.vegan": "Sí, también tenemos opciones veganas en nuestro menú.",
"front.faq.chat.answer.allergens": "Si tienes alergias o intolerancias, ponte en contacto con nosotros directamente. Con gusto te daremos información sobre los ingredientes.",
"front.faq.chat.answer.takeaway": "Sí, también se puede pedir comida para llevar.",
"front.faq.chat.answer.delivery": "Por el momento, a través del sitio web solo admitimos reservas y preguntas.",
"front.faq.chat.answer.terrace": "Sí, con buen tiempo también puedes sentarte en nuestra terraza.",
"front.faq.chat.answer.pets": "Ponte en contacto con nosotros directamente si deseas venir con una mascota.",
"front.faq.chat.answer.children": "Sí, las familias con niños son muy bienvenidas.",
"front.faq.chat.answer.wifi": "Sí, hay Wi-Fi disponible para nuestros huéspedes.",

"front.acquaintance.callback.placeholder": "Tu número de teléfono",
"front.acquaintance.callback.send": "Enviar",
"front.acquaintance.callback.sending": "Enviando...",
"front.acquaintance.callback.invalidPhone": "Introduce un número de teléfono válido.",
"front.acquaintance.callback.success": "Solicitud enviada. Me pondré en contacto contigo pronto.",
"front.acquaintance.callback.error": "Error al enviar la solicitud. Inténtalo de nuevo.",

"front.landingSeo.links.digitalMenu": "Menú digital para restaurantes",
"front.landingSeo.links.qrMenu": "Menú con código QR para restaurantes",
"front.landingSeo.links.multilingualMenu": "Menú multilingüe para restaurantes",
"front.landingSeo.links.reservation": "Reserva de mesas online para restaurantes",
"front.landingSeo.links.freeDigitalMenu": "Prueba gratis un menú digital",
"front.landingSeo.links.changeMenuOnline": "Cambiar el menú online",

"menu.title": "Menú",
"menu.promo": "Ofertas especiales",
"menu.empty.categoryTitle": "Completa el nombre de la categoría",
"menu.empty.itemTitle": "Completa el nombre del producto",
"menu.empty.itemDescription": "Completa la descripción del producto",
"cart.add": "Añadir al carrito",
"cart.cancel": "Cancelar",
"section.video": "Presentación en video",
"section.tables": "RESERVA DE MESA ONLINE",
"section.table": "ELIGE UNA MESA",
"section.menu": "Menú del restaurante",
"section.faq": "FAQ",
"section.contact": "Contacto",
"promo.buy": "Comprar",

"front.tenant.resolving": "Detectando restaurante por subdominio…",
"front.tenant.notFound": "No se encontró ningún cliente para este subdominio",
"front.tenant.resolveError": "No se pudo identificar al cliente",
"front.menu.loading": "Cargando…",
"front.menu.loadError": "No se pudo cargar el menú",
"front.menu.addtocart": "Carrito",
"front.menu.cancel": "Cancelar",
"front.Number.servings": "Número de porciones",

"orbit.menu": "MENÚ",
"orbit.shef": "RESERVA",
"orbit.video": "VIDEO",
"orbit.faq": "PREGUNTAS",
"orbit.interior": "INTERIOR",
"orbit.footer": "REDES SOCIALES",

"shef.title.line1": "ONLINE",
"shef.title.line2": "RESERVA",
"shef.banner.label": "Elige",
"shef.banner.main": "tu mesa",
"shef.reserved": "RESERVADO",

"video.title": "ASÍ COCINAMOS — CON HONESTIDAD Y SABOR",
"video.add": "Añadir video",
"add.video.but": "Añadir",

"interior.title": "NUESTRO INTERIOR",

"footer.kontact": "CONTACTOS",

"telegram.title": "Para configurar notificaciones de pedidos en Telegram, debes:",
"telegram.title.first": "1. Obtener BOT_TOKEN",
"telegram.text.first": "Para obtener un BOT_TOKEN, busca e inicia el bot @BotFather en Telegram, envía el comando /newbot, sigue las instrucciones para crear un nombre y un username únicos para el bot, y luego copia el token API que @BotFather envía como respuesta.",
"telegram.title.two": "2. Obtener CHAT_ID",
"telegram.text.two": "Para obtener el CHAT_ID, busca e inicia el bot @UserInfoBot en Telegram, envía el comando /start y luego copia el ID que recibirás en el mensaje de respuesta.",

"cart.title": "TU CARRITO",
"cart.header.aria": "Tu carrito",
"cart.toggle.expand": "Expandir carrito",
"cart.toggle.collapse": "Contraer carrito",
"cart.total.label": "Total",
"cart.total.products": "productos",
"cart.button.primary": "pedir",
"cart.button.back": "atrás",
"cart.button.waiter": "CAMARERO",

"cart.mode.takeaway": "para llevar",
"cart.mode.tableTime": "Hora y mesa",
"cart.mode.tableTime.disabled": "no hay mesas libres",
"cart.mode.tableTime.tooltip": "Hora y mesa",
"cart.mode.tableTime.tooltipNoFree": "no hay mesas libres",
"cart.mode.inHouse": "en el local",

"cart.bookingFlow.title": "RESERVA. NÚMERO DE MESA",
"cart.deposit.itemTitle": "Reserva de mesa (depósito)",
"cart.deposit.lineTitle": "Depósito",
"cart.deposit.badge": "Depósito {amount}€",

"cart.table.msg.tempChosen": "Mesa {table} seleccionada temporalmente ✓",
"cart.table.msg.noFree": "Lamentablemente no hay mesas libres",
"cart.table.msg.chooseOrDefault": "Por favor, elige una mesa o usa la selección predeterminada.",

"cart.table.select.reserved": "RESERVADO",
"cart.table.select.pick": "ELEGIR",
"cart.table.select.any": "CUALQUIERA",

"cart.inHouse.title": "ELIGE TU NÚMERO DE MESA",
"cart.inHouse.select.placeholder": "Elegir mesa",
"cart.inHouse.select.option": "Mesa #{n}",

"cart.checkout.back": "Atrás",
"cart.payment.preparing": "Preparando el pago…",
"cart.loading": "Cargando…",

"mockCheckout.title.paymentMethod": "MÉTODO DE PAGO",
"mockCheckout.method.card": "Tarjeta bancaria",
"mockCheckout.method.paypal": "PayPal",
"mockCheckout.method.gpay": "Google Pay",
"mockCheckout.cardForm.title": "INTRODUCE LOS DATOS DE LA TARJETA",
"mockCheckout.cardForm.numberLabel": "NÚMERO DE TARJETA",

"mockCheckout.error.invalidCardNumber": "Número de tarjeta no válido",
"mockCheckout.error.enter16Digits": "Introduce 16 dígitos",
"mockCheckout.error.expiryFormat": "Formato MM/AA",
"mockCheckout.error.expiryMonthRange": "Mes 01–12",
"mockCheckout.error.cardExpired": "La tarjeta ha caducado",
"mockCheckout.error.cvc3Digits": "3 dígitos",

"mockCheckout.error.sendTelegram": "Error al enviar a Telegram",
"mockCheckout.error.generic": "Algo salió mal",

"mockCheckout.reserve.clientNotFound": "Cliente no encontrado",
"mockCheckout.reserve.tablesNotFound": "Este cliente no tiene sección de mesas",
"mockCheckout.reserve.tableNotFound": "Mesa no encontrada",
"mockCheckout.reserve.alreadyReserved": "Esta mesa acaba de ser ocupada. Por favor, elige otra.",
"mockCheckout.reserve.noFreeTables": "Actualmente no hay mesas libres",
"mockCheckout.reserve.tableNotSelected": "Por favor, elige una mesa",
"mockCheckout.reserve.genericError": "Error de reserva",

"mockCheckout.button.back": "atrás",
"mockCheckout.button.pay": "PAGAR",
"mockCheckout.button.sending": "…enviando",
"mockCheckout.button.paid": "...",
"mockCheckout.button.payInvalidTitle": "Por favor, revisa los datos de la tarjeta",

"admin.booking.lead.title": "TIEMPO MÍNIMO DE RESERVA",
"admin.booking.lead.note": "Esto solo afecta a las reservas de invitados en modo “mesa y hora”. El intervalo es de 30 minutos.",

"dateTimeStep.select.time": "SELECCIONAR HORA",

"admin.title": "PANEL DE ADMINISTRACIÓN",
"admin.loading": "Cargando…",
"admin.nav.delete": "Eliminar",
"admin.nav.back": "Atrás",
"admin.nav.next": "SIGUIENTE",
"admin.nav.confirm": "GUARDAR",
"admin.nav.confirm.now": "guardando ...",
"admin.booking.settings": "Configuración de reservas",
"admin.booking.deposit": "IMPORTE DEL DEPÓSITO",
"admin.booking.deposit.note": "El depósito se cobra cuando el huésped solo reserva una mesa",

"admin.hub.editmenu": "EDITAR MENÚ",
"admin.hub.qr": "CÓDIGO QR",
"admin.hub.prices": "TU PLAN",
"admin.hub.settings": "CONFIGURACIÓN",

"admin.panel.editmenu": "Editar menú",
"admin.validation.required": "Campo obligatorio",
"admin.panel.add": "Añadir posición",
"admin.panel.menu": "Editar lista del menú",
"admin.panel.telegram": "Telegram",
"admin.panel.table": "GESTIÓN DE MESAS",
"admin.set.table": "Salas / mesas",
"admin.set.logo": "Logo y fondos",
"admin.logo.successfully.applied": "Logo aplicado correctamente",
"admin.logo.download.error": "Error de descarga",
"admin.settings.number.rooms": "Número de salas",
"admin.settings.room": "Sala",

"admin.qr.title": "Código QR para huéspedes",
"admin.qr.alt": "QR para restaurante",
"admin.qr.copy": "copiar enlace",
"admin.qr.copied": "✓ copiado",
"admin.qr.note": "Los huéspedes pueden escanear este código para abrir tu página al instante.",

"admin.link.notfound": "Enlace no encontrado",
"admin.table.info": "La gestión de mesas está disponible en esta página. El estado cambia al presionar la mesa.",
"admin.prices.temp": "Los precios no están disponibles temporalmente.",
"admin.forgot.password": "¿Olvidaste tu contraseña?",
"admin.success.description": "Haz clic en OK y añade otro producto",

"order.success": "¡Artículo añadido al carrito!",
"order.error": "Este artículo ya está en el carrito",

"popap.product.removal": "Eliminación de producto",
"popap.category.removal": "Eliminación de categoría",
"popap.want.delete.product": "¿Seguro que quieres eliminar el producto?",
"popap.want.delete.category": "¿Seguro que quieres eliminar la categoría?",

"admin.settings.guestLang": "Idioma predeterminado para huéspedes",
"admin.settings.adminLang": "Idioma predeterminado para admin",
"admin.settings.noteGuest": "Este idioma se establecerá como predeterminado cuando los huéspedes abran la página.",
"admin.settings.noteAdmin": "Este idioma se establecerá como predeterminado en el panel de administración.",
"admin.language": "Idioma",
"admin.settings.logo": "Logo del restaurante",
"admin.settings.logo.text": "Sube tu logo (PNG/JPG/WEBP/SVG, hasta 2 MB). Luego haz clic en “Guardar”; esto reemplazará el logo actual por el nuevo.",
"admin.settings.backtable": "Imagen de fondo en la pantalla de selección de mesas",
"admin.settings.backhome": "Imagen de fondo de la pantalla principal",
"admin.settings.backtable.text": "Sube una imagen de fondo (SVG/PNG/JPG/WEBP). Luego haz clic en “Guardar”; esto reemplazará el fondo actual por el nuevo.",
"admin.settings.language.visitors": "Idioma principal para los visitantes del restaurante",
"admin.settings.language.visitors.text": "Este idioma se establecerá como idioma principal cuando los huéspedes abran la página",
"admin.settings.language.admin": "Idioma principal de tu panel de administración",
"admin.settings.language.admin.text": "Este idioma se establecerá como predeterminado al abrir el panel de administración",
"admin.settings.gallery": "Galería",
"admin.settings.social": "Redes sociales",
"admin.settings.number.tables": "Número de mesas",
"admin.settings.how.many.tables": "¿Cuántas mesas hay en el restaurante?",
"admin.settings.tables.test": "Guarda el número de mesas y vuelve a la pestaña anterior para configurar cada mesa por separado.",
"admin.settings.upload.panoramic": "Sube una foto panorámica de la sala de tu restaurante",
"admin.settings.table": "Mesa",
"admin.settings.table.not.found": "Mesa no encontrada",
"admin.settings.contact.details": "Datos de contacto",
"admin.contacts.company": "Nombre de la empresa",
"admin.contacts.address": "Dirección",
"admin.contacts.phone": "Número de teléfono",
"admin.socials.title": "Redes sociales",
"admin.settings.rooms.hint": "Indica el número de salas del restaurante",

"admin.settable.title": "Paso 3. Numeración de mesas",
"admin.settable.text1": "Cada etiqueta tiene un número; coloca las etiquetas según los números de las mesas.",
"admin.settable.text2": "Usa el interruptor para cambiar el tamaño de la etiqueta.",
"admin.settable.text3": "Guarda los datos de la mesa actual y haz clic en el icono correspondiente para cambiar entre mesas.",
"admin.setqr.title": "Tus códigos QR",
"admin.setqr.text1": "en esta página se guardan tus mensajes, menús y códigos QR",
"admin.setqr.text2": "al comprar el plan BASIC se generará automáticamente un código QR y un enlace a tu subdominio (por ejemplo example.best-place.club)",
"admin.setqr.text3": "puedes abrir el enlace, copiarlo y también guardar el código QR como imagen en tu dispositivo",
"admin.setpanorama.title": "Paso 2. Foto panorámica",
"admin.setpanorama.text1": "Añade una foto panorámica. Se recomienda usar archivos ligeros, por ejemplo en formato WEBP.",
"admin.setpanorama.text2": "Si la imagen se ha subido correctamente, la verás en la vista previa de abajo.",
"admin.setnumber.title": "Paso 1. Número de mesas",
"admin.setnumber.text1": "Elige el número de mesas en tu restaurante",
"admin.setnumber.text2": "Se recomienda empezar la configuración con una o dos mesas y luego aumentar el número.",

"admin.current.logo": "Logo actual",
"admin.add.photo": "aquí puedes añadir un archivo",
"admin.add.file": "formatos de archivo para subir: .xlsx, .xls, .csv",
"admin.add.file.but": "Añadir archivo",
"admin.import.format": "Formato de columnas: Categoría / Título / Descripción / Precio",
"admin.import.follow": "sigue el formato de columnas indicado y prepara un archivo en el formato correspondiente",
"admin.import.BeСareful": "Atención: durante la importación se perderán los datos anteriores",
"admin.add.photo.but": "Añadir foto",
"admin.add.photo.set": "Añadir foto",

"admin.wizard.step1": "Elegir categoría",
"admin.wizard.step2": "Nombre y precio",
"admin.wizard.step3": "Descripción y foto",
"admin.wizard.ready": "Listo",
"admin.wizard.defaultTitle": "Añadir producto",
"admin.wizard.step1.desc": "Paso 1. Elige una categoría existente o crea una nueva",
"admin.wizard.step2.desc": "Paso 2. Elige el nombre del producto y establece el precio",
"admin.wizard.step3.desc": "Paso 3. Escribe una descripción del producto, añade una imagen y haz clic en guardar",
"admin.wizard.step1.desc.short": "Paso 1. Elige una categoría existente o nueva",
"admin.wizard.step2.desc.short": "Paso 2. Añade el nombre y el precio del producto",
"admin.wizard.step3.desc.short": "Paso 3. Describe el producto y añade una foto",

"admin.wizard.tab.existing": "Existente",
"admin.wizard.tab.new": "Nueva",
"admin.wizard.cat.loading": "Cargando…",
"admin.wizard.cat.empty": "Todavía no hay categorías. Cambia a “Nueva” y crea la primera.",

"admin.form.categoryKeyDe": "Categoría (KEY/ES)",
"admin.form.categoryEn": "Categoría (EN)",
"admin.form.titleMain": "Nombre del producto",
"admin.form.descMain": "Descripción del producto",
"admin.validation.req": "Introduce el nombre del producto",
"admin.form.titleDe": "Título (DE)",
"admin.form.titleEn": "Título (EN)",
"admin.form.nameDe": "Nombre (DE)",
"admin.form.nameEn": "Nombre (EN)",
"admin.form.price": "Precio",
"admin.form.descDe": "Descripción (DE)",
"admin.form.descEn": "Descripción (EN)",

"admin.toast.productAdded": "Producto añadido correctamente",
"admin.tooltip.fixFormErrors": "Corrige los errores del formulario",

"admin.validation.firstCharNotDigit": "El primer carácter no puede ser un dígito.",
"admin.validation.maxChars": "acorta el nombre del producto",
"admin.validation.chooseCategory": "Elige una categoría.",
"admin.validation.chooseCategoryFromList": "Elige una categoría de la lista.",
"admin.validation.enterCategoryName": "Introduce un nombre de categoría.",
"admin.validation.enterProductName": "Introduce un nombre de producto.",
"admin.validation.priceFormat": "Formato de precio no válido (por ejemplo 12.50)",
"admin.validation.enterDescription": "Introduce una descripción.",
"admin.tarif.apply": "aplicar",
"admin.menu.creating": "Crear menú",
"admin.choose.template": "Paso 1: Elige una plantilla",
"admin.choose.template2": "Paso 2: Revisa las líneas de productos",
"admin.choose.atyle": "Elige un estilo de menú. Puedes cambiarlo más tarde",

"admin.error.tenantNotFound": "No se encontró ningún cliente para este subdominio.",
"admin.error.resolveClient": "No se pudo identificar al cliente.",
"admin.error.menuLoad": "No se pudo cargar el menú.",
"admin.error.saveLang": "No se pudo guardar el idioma.",
"admin.error.clientNotFound": "Cliente no encontrado en el servidor",
"admin.error.arrNotFound": "Array de datos no encontrado para este cliente",

"tpl.premium.title": "Premium",
"tpl.classic.title": "Clásico",
"tpl.dark.title": "Oscuro",
"tpl.minimal.title": "Minimalista",
"tpl.premium.desc": "Más vendido",
"tpl.classic.desc": "claro",
"tpl.dark.desc": "oscuro",
"tpl.minimal.desc": "minimalista",

"tp2.position.total": "Ahora tienes:",
"tp2.position.punkte": "Elementos del menú",
"tp2.position.template": "Plantilla",

"tp3.qr.link": "Código QR y enlace del menú",
"tp3.step3.title": "Paso 3: Vista previa / Publicación",
"admin.tp.progres.publication": "Publicación",
"admin.tp.progres.positionen": "Posición",

"tp4.link.copy": "COPIAR",
"tp4.link.copy.ok": "✓ COPIADO",

"admin.tp.publish": "Publicar",
"admin.tp.posting": "publicando ...",

"admin.import.from.excel": "Importar menú desde Excel",

"popap.successful.payment": "Pago realizado correctamente",

"landing.title": "Soluciones digitales para restaurantes",
"landing.title.login": "Acceso",
"landing.text": "¡Lanza el sitio web de tu restaurante en pocos minutos!",
"landing.try.now": "probar gratis",
"landing.title.to": "¿Para quién es adecuado nuestro servicio?",
"landing.title.answer": "En primer lugar, será útil para propietarios de restaurantes cuyo objetivo es atraer nuevos clientes y conservar los existentes",
"landing.content.title.first": "Menú online con código QR",
"landing.content.first": "Tus visitantes pueden contar con un menú y precios actualizados simplemente escaneando el código QR. Las ofertas especiales aumentarán la fidelidad de los visitantes hacia tu producto",
"landing.content.title.second": "Reservas de mesa online",
"landing.content.second": "Ofrecemos a los huéspedes una reserva visual de mesa online con fotos panorámicas adicionales. Si es necesario, pueden cambiar entre zonas cercanas",
"landing.content.title.third": "Contenido con ambiente",
"landing.content.third": "Los visitantes potenciales pueden ver distintos contenidos: fotos del interior, videos de la preparación de los mejores platos y una vista panorámica de la sala.",
"landing.content.title.four": "Aumenta el ticket medio",
"landing.content.four": "Ofrece a tus huéspedes eventos como banquetes, cumpleaños u ofertas especiales para pedidos grandes o diarios",
"landing.request": "Nos pondremos en contacto contigo pronto",
"callback.invalidPhone": "Introduce un número de teléfono válido",
"landing.enter.number": "TU NÚMERO",
"callback.submitError": "No se pudo enviar el número. Inténtalo de nuevo",
"landing.tariff.advance": "Advertencia",
"landing.tariff.advance.desc": "Dentro del plan elegido puedes llenar tu aplicación con contenido de forma gratuita",
"landing.tariff.one-time-not-included": "Cálculo de precio individual. En la esquina derecha de la pantalla encontrarás un botón de contacto. Deja tu número y nos pondremos en contacto contigo",
"landing.tariff.one-time-services": "Servicios únicos",
"landing.tariff.logo-creation": "Creación de logo",
"landing.tariff.selling-images": "Venta de imágenes de productos",
"landing.tariff.panorama-creation": "Creación de panorama",

"demo.video.unsupported": "Tu navegador no admite video",
"demo.title.after": "resumen del servicio",
"demo.title.accent": "breve",
"demo.title.before": "Un",
"demo.title.total": "sobre el servicio",
"demo.title": "Resumen en video",

"landing.free.first": "Menú online mediante código QR disponible, resultado en pocos minutos.",
"landing.free.second": "Posibilidad de editar el menú para la fecha actual",
"landing.free.third": "Acceso al diseñador de menús",
"landing.basic.first": "Una página URL completa con acceso al menú mediante código QR",
"landing.basic.second": "Pedidos en línea para sus visitantes",
"landing.basic.third": "Reservas de mesa online, fotos panorámicas de tu comedor, mesas clicables y visualización en tiempo real de mesas reservadas y disponibles",
"landing.basic.fourth": "Menú con traducción a cualquier idioma.",
"landing.pro.first": "Funcionalidad que permite gestionar ofertas de precios, crear banners y estrategias de marketing",
"landing.pro.second": "Posibilidad de gestionar el sistema de fidelización de huéspedes e influir en el resultado final de las reseñas de Google",
"landing.pro.third": "",
"landing.title.free": "Gratis durante 14 días",
"landing.registerTitle": "Registro",
"landing.tariff.selection": "Selección de plan",
"landing.tariff.subdomain": "Registro de subdominio",
"landing.tariff": " / al mes",
"landing.your.tariff": "tu plan",
"landing.your.example": "por ejemplo",
"landing.Subdomain.selection": "Selección de subdominio",
"landing.password": "contraseña",
"landing.tariff.free": "GRATIS",
"landing.tariff.free-description": "para conocer el servicio",
"landing.tariff.basic": "BASIC",
"landing.tariff.basic-description": "funciones básicas para empezar",
"landing.tariff.pro": "PRO",
"landing.tariff.pro-description": "Para usuarios avanzados",
"landing.tariff.selected": "✓ seleccionado",
"landing.legal.text.start": "Acepto los",
"footer.legal.terms": "Términos",
"landing.legal.text.mid": "y",
"landing.tariff.optional": "Servicios únicos",
"landing.tariff.one-time-note": "Ver tarifas para crear imágenes de alta calidad orientadas a la venta",
"landing.tariff.pro-locked-desc": "Este plan aún no está disponible",
"landing.tariff.in-development": "En desarrollo",
"landing.tariff.free-one-time-desc": "para llenar tu publicación con imágenes de alta calidad",

"footer.legal.privacy": "Privacidad",
"footer.legal.privacy.and": "política",
"footer.about": "Plataforma para restaurantes: menú, reservas de mesa, pedidos y panel de administración.",

"server.common.unknown": "Error desconocido.",
"server.common.serverError": "Error interno del servidor.",
"server.common.networkError": "Error de red. Inténtalo de nuevo.",
"server.common.clientIdMissing": "Error: falta clientId.",

"server.login.required": "El email y la contraseña son obligatorios.",
"server.login.invalidCredentials": "Email o contraseña no válidos.",
"server.login.signupIncomplete": "La cuenta aún no está activa. Completa el registro.",
"server.login.success": "¡Inicio de sesión correcto!",

"server.register.required": "El email y la contraseña son obligatorios.",
"server.register.emailExistsActive": "Ya existe un usuario con este email. Usa Login.",
"server.register.resume": "Continuando el registro.",
"server.register.success": "¡Registro correcto!",

"server.signupComplete.success": "¡Activación correcta!",
"server.signupComplete.error": "Error de activación.",

"server.subdomain.required": "clientId y subdominio son obligatorios.",
"server.subdomain.planInvalid": "Plan no válido. Permitidos: free | basic | pro.",
"server.subdomain.invalid": "Subdominio no válido (a-z, 0-9, '-', 3–30, sin '-' al inicio/final).",
"server.subdomain.reserved": "Este subdominio está reservado.",
"server.subdomain.taken": "Este subdominio ya está ocupado.",
"server.subdomain.userNotFound": "Usuario no encontrado.",
"server.subdomain.success": "Subdominio registrado. Redirigiendo…",
"server.subdomain.error": "Error al registrar el subdominio.",

"landing.loginTitle": "Login",
"landing.btn.login": "Login",
"landing.btn.register": "Registro",
"landing.btn.enter": "Entrar",
"landing.loggingIn": "Iniciando sesión…",
"landing.registering": "Registrando…",
"landing.activating": "Activando…",
"landing.subdomain.registering": "Registrando subdominio…",
"landing.redirecting": "Redirigiendo…",
"landing.legal.required": "Por favor, acepta los términos y la política de privacidad.",

"landing.subdomain.err.empty": "Introduce un subdominio.",
"landing.subdomain.err.chars": "Solo letras, números y '-', 3–30 caracteres.",
"landing.subdomain.err.hyphen": "El subdominio no puede empezar ni terminar con '-'.",
"landing.subdomain.err.reserved": "Este subdominio está reservado.",

"admin.menuLanguages.title": "Idiomas del menú",
"admin.menuLanguages.default": "El idioma que un visitante de su establecimiento verá primero (por defecto)",
"admin.menuLanguages.hint": "Seleccione los idiomas que se utilizarán adicionalmente",
"common.success": "Correcto",
"admin.import.activeLangs": "Idiomas del menú activo",
  "admin.import.sourceLangHint": "Excel verður aðeins skrifað á völdu tungumáli. Önnur virk tungumál verða auð",
  "admin.import.sourceLang": "Especifique el idioma en el que está escrito el archivo de Excel",
  "admin.import.mainLang": "el principal",
  "booking.date.today": "Hoy",
  "booking.date.tomorrow": "Mañana",
  "booking.room": "Sala",

"front.faq.chat.answer.greeting": "¡Hola! Puedo ayudarte con reservas, menú, dirección, horarios de apertura y otras preguntas.",
"front.faq.chat.answer.howAreYou": "Gracias, estoy bien. ¿En qué puedo ayudarte sobre el restaurante?",
"front.faq.chat.answer.thanks": "¡De nada! Escríbenos si tienes más preguntas.",
"front.faq.chat.answer.goodbye": "¡Hasta luego! Estaremos encantados de recibirte.",
"front.faq.chat.answer.whoAreYou": "Soy el asistente digital del restaurante. Ayudo a los clientes con preguntas frecuentes.",
"front.faq.chat.answer.help": "Puedo ayudarte con reservas, menú, dirección, número de teléfono, pagos, alérgenos, entrega y otras preguntas.",
"front.faq.chat.answer.recommendation": "Te recomiendo revisar el menú — allí encontrarás los platos actuales y podrás elegir lo que más te guste.",
"front.faq.chat.answer.compliment": "¡Muchas gracias! Nos alegra escucharlo.",

"checkout.button.send": "ENVIAR",
"checkout.button.sending": "Enviando ...",
"checkout.button.sent": "Enviado",
"checkout.title.order": "PEDIDO",
"checkout.phone.title": "Introduce tu número de teléfono",
"checkout.phone.label": "Número de teléfono",

"footer.workingHours": "Horas de trabajo",

"admin.offline.title": "Sin conexión a Internet",
"admin.offline.text": "Comprueba tu conexión a Internet. Podrás seguir trabajando automáticamente cuando se restablezca la conexión.",
"admin.offline.status": "Esperando conexión…",



};

export default es;
